/* =============================================
   SB Filter Drawer – Accordion & Price Range
   ============================================= */

(function () {
  function initSbFilterDrawer() {
    // ---- Accordion ----
    document.querySelectorAll('[data-sb-accordion-toggle]').forEach(function (btn) {
      if (btn._sbInit) return;
      btn._sbInit = true;
      function toggleAccordion() {
        var accordion = btn.closest('[data-sb-accordion]');
        var isOpen = accordion.classList.contains('sb-accordion--open');
        accordion.classList.toggle('sb-accordion--open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      }
      btn.addEventListener('click', toggleAccordion);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleAccordion(); }
      });
    });

    // ---- Price range sliders ----
    document.querySelectorAll('.sb-price-range').forEach(function (wrapper) {
      if (wrapper._sbInit) return;
      wrapper._sbInit = true;

      var minRange = wrapper.querySelector('.sb-range-input--min');
      var maxRange = wrapper.querySelector('.sb-range-input--max');
      var fill = wrapper.querySelector('.sb-price-range__fill');
      var minLabel = wrapper.querySelector('.sb-price-display--min');
      var maxLabel = wrapper.querySelector('.sb-price-display--max');
      var minText = wrapper.querySelector('price-range .sb-price-text-input:first-of-type');
      var maxText = wrapper.querySelector('price-range .sb-price-text-input:last-of-type');

      if (!minRange || !maxRange) return;

      var rangeMax = parseFloat(wrapper.dataset.max) || 1000;

      function updateFill() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        var leftPct = (minVal / rangeMax) * 100;
        var widthPct = ((maxVal - minVal) / rangeMax) * 100;
        fill.style.left = leftPct + '%';
        fill.style.width = Math.max(0, widthPct) + '%';
      }

      function updateLabels() {
        if (minLabel) minLabel.textContent = Math.round(parseFloat(minRange.value));
        if (maxLabel) maxLabel.textContent = Math.round(parseFloat(maxRange.value));
      }

      minRange.addEventListener('input', function () {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (minVal > maxVal) { minRange.value = maxVal; minVal = maxVal; }
        updateFill();
        updateLabels();
        if (minText) {
          minText.value = Math.round(minVal);
          minText.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      maxRange.addEventListener('input', function () {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (maxVal < minVal) { maxRange.value = minVal; maxVal = minVal; }
        updateFill();
        updateLabels();
        if (maxText) {
          maxText.value = Math.round(maxVal);
          maxText.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      if (minText) {
        minText.addEventListener('change', function () {
          var val = Math.min(parseFloat(minText.value) || 0, parseFloat(maxRange.value));
          minRange.value = val;
          updateFill();
          updateLabels();
        });
      }

      if (maxText) {
        maxText.addEventListener('change', function () {
          var val = Math.max(parseFloat(maxText.value) || rangeMax, parseFloat(minRange.value));
          maxRange.value = val;
          updateFill();
          updateLabels();
        });
      }

      updateFill();
      updateLabels();
    });
  }

  // ---- Dimension range sliders (Width / Depth / Height metafields) ----
  function initSbDimRanges() {
    document.querySelectorAll('.sb-dim-range').forEach(function (wrapper) {
      if (wrapper._sbDimInit) return;
      wrapper._sbDimInit = true;

      var minRange = wrapper.querySelector('.sb-range-input--min');
      var maxRange = wrapper.querySelector('.sb-range-input--max');
      var fill = wrapper.querySelector('.sb-price-range__fill');
      var minLabel = wrapper.querySelector('.sb-price-display--min');
      var maxLabel = wrapper.querySelector('.sb-price-display--max');
      var minText = wrapper.querySelector('[data-role="dim-min-text"]');
      var maxText = wrapper.querySelector('[data-role="dim-max-text"]');
      var checkboxes = wrapper.querySelectorAll('.sb-dim-checkbox');

      if (!minRange || !maxRange || checkboxes.length === 0) return;

      var rangeMin = parseFloat(wrapper.dataset.min);
      var rangeMax = parseFloat(wrapper.dataset.max);
      var span = rangeMax - rangeMin;

      function updateFill() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (span === 0) return;
        var leftPct = ((minVal - rangeMin) / span) * 100;
        var widthPct = ((maxVal - minVal) / span) * 100;
        fill.style.left = leftPct + '%';
        fill.style.width = Math.max(0, widthPct) + '%';
      }

      function updateLabels(fromSlider) {
        var minVal = Math.round(parseFloat(minRange.value));
        var maxVal = Math.round(parseFloat(maxRange.value));
        if (minLabel) minLabel.textContent = minVal;
        if (maxLabel) maxLabel.textContent = maxVal;
        if (fromSlider) {
          if (minText) minText.value = minVal;
          if (maxText) maxText.value = maxVal;
        }
      }

      var debounceTimer;
      function syncCheckboxes() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        var isFullRange = (minVal <= rangeMin && maxVal >= rangeMax);
        checkboxes.forEach(function (cb) {
          var val = parseFloat(cb.value);
          cb.checked = !isFullRange && (val >= minVal && val <= maxVal);
        });
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          checkboxes[0].dispatchEvent(new Event('change', { bubbles: true }));
        }, 400);
      }

      minRange.addEventListener('input', function () {
        if (parseFloat(minRange.value) > parseFloat(maxRange.value)) minRange.value = maxRange.value;
        updateFill(); updateLabels(true); syncCheckboxes();
      });

      maxRange.addEventListener('input', function () {
        if (parseFloat(maxRange.value) < parseFloat(minRange.value)) maxRange.value = minRange.value;
        updateFill(); updateLabels(true); syncCheckboxes();
      });

      if (minText) {
        minText.addEventListener('change', function () {
          var val = Math.max(rangeMin, Math.min(parseFloat(minText.value) || rangeMin, parseFloat(maxRange.value)));
          minRange.value = val;
          updateFill(); updateLabels(); syncCheckboxes();
        });
      }

      if (maxText) {
        maxText.addEventListener('change', function () {
          var val = Math.min(rangeMax, Math.max(parseFloat(maxText.value) || rangeMax, parseFloat(minRange.value)));
          maxRange.value = val;
          updateFill(); updateLabels(); syncCheckboxes();
        });
      }

      updateFill();
      updateLabels();
    });
  }

  function initAll() {
    initSbFilterDrawer();
    initSbDimRanges();
  }

  // Expose so facets.js can re-init after AJAX filter updates replace drawer innerHTML
  window.initSbFilterDrawer = initSbFilterDrawer;
  window.initSbDimRanges = initSbDimRanges;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the drawer opens (theme may render it lazily)
  document.addEventListener('on:menu-drawer:open', initAll);
  document.addEventListener('on:drawer:open', initAll);
})();

